import React from "react"
import PropTypes from "prop-types"
import noop from "lodash/noop"
import cn from "classnames"
import TooltipWrapper from "src/components/Tooltips/TooltipWrapper"
import UnlockedIcon from "src/icons/unlocked.svg"
import LockedIcon from "src/icons/locked.svg"
import styles from "./styles.css"

const LockIcon = ({ isLocked, disabled }) =>
  isLocked ? (
    <LockedIcon
      size="medium"
      className={disabled ? styles.lockError : cn(styles.lockIcon, styles.icon)}
      color="#000"
    />
  ) : (
    <UnlockedIcon
      size="medium"
      className={disabled ? styles.lockError : cn(styles.lockIcon, styles.icon)}
      color="#aaa"
    />
  )

LockIcon.propTypes = {
  isLocked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
}

const LockButton = ({ onClick, tooltip, isLocked, disabled }) => (
  <button
    type="button"
    onClick={disabled ? noop : onClick}
    className={styles.transparent}
  >
    {tooltip ? (
      <TooltipWrapper
        className={styles.tooltip}
        tooltipLabel={tooltip}
        tooltipPosition="bottom"
        tooltipStyle={{
          margin: `-25px 0 0 -50px`,
          width: `200px`,
        }}
        tooltipFixed
      >
        <LockIcon isLocked={isLocked} disabled={disabled} />
      </TooltipWrapper>
    ) : (
      <LockIcon isLocked={isLocked} disabled={disabled} />
    )}
  </button>
)

LockButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isLocked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  tooltip: PropTypes.string,
}

LockButton.defaultProps = {
  tooltip: null,
}

export default LockButton
